var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_c('li',[_vm._v(" properties ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }